export const FEATURE_FLAG_MERGE_PROFILES = 'merge-profiles'
export const FEATURE_FLAG_STANDALONE_PROVISIONING = 'standalone-provisioning'
